module.exports = __webpack_public_path__ + "img/wilderness_hut.eb7e6c12.svg";